import 'core-js/stable';
import 'regenerator-runtime/runtime';
import FontFaceObserver from 'fontfaceobserver';
import { render as renderCore } from 'ia-react-core';
import App from './app';

const render = () => {
  renderCore(App);
};

const montserrat = new FontFaceObserver('Montserrat');
const openSans = new FontFaceObserver('Open Sans');

// eslint-disable-next-line @typescript-eslint/no-floating-promises
Promise.all([montserrat.load(), openSans.load()])
  .then(() => {
    render();
  });
